import { render, staticRenderFns } from "./Tender.vue?vue&type=template&id=64873c14"
import script from "./Tender.vue?vue&type=script&lang=js"
export * from "./Tender.vue?vue&type=script&lang=js"
import style0 from "./Tender.vue?vue&type=style&index=0&id=64873c14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports